export function Spacing(props: { type?: 'vertical' | 'horizontal'; spacing: number }) {
  const { type = 'vertical', spacing } = props;

  return (
    <div
      style={{
        display: type === 'horizontal' ? 'inline-block' : 'block',
        minWidth: type === 'horizontal' ? `${spacing}px` : '',
        minHeight: type === 'vertical' ? `${spacing}px` : '',
      }}
    />
  );
}
